import { keepPreviousData } from '@tanstack/react-query';
import { useInfiniteRequest } from '@shared/config/query/hooks';
import type {
  CandidateRequestParams,
  CandidateResumeSummary,
} from '../../types';
import { candidatesApi } from '../candidatesApi';
import { candidateQueryKeys } from '../queryKeys';

export const useGetCandidateResumes = (
  candidateId: number,
  params: CandidateRequestParams
) => {
  return useInfiniteRequest<CandidateResumeSummary>({
    queryKey: candidateQueryKeys.resumes(candidateId, params),
    queryFn: ({ pageParam }) =>
      candidatesApi.getCandidateResumes(candidateId, {
        ...params,
        ...pageParam,
      }),
    initialPageParam: {
      perPage: params.perPage,
      page: params.page,
    },
    placeholderData: keepPreviousData,
  });
};
